import React from 'react'
import ReactDOM from 'react-dom'

import { AppTivioProvider } from './components/context/AppTivioProvider'
import { BundleProvider } from './components/context/BundleProvider'
import { ConfigProvider } from './components/context/ConfigProvider'
import { CustomerProvider } from './components/context/CustomerProvider'
import { useBundle } from './components/hooks/useBundle'
import { ENV } from './env'
import './polyfill'


const AppContainer: React.FC = () => {
    const { components } = useBundle()
    const { TvApp } = components

    return (
        <TvApp customer={ENV.CUSTOMER}/>
    )
}

ReactDOM.render(
    <React.StrictMode>
        <CustomerProvider customer={ENV.CUSTOMER}>
            <AppTivioProvider>
                <ConfigProvider>
                    <BundleProvider>
                        <AppContainer/>
                    </BundleProvider>
                </ConfigProvider>
            </AppTivioProvider>
        </CustomerProvider>
    </React.StrictMode>,
    document.getElementById('root'),
)
